type ApiConfig = {
  ClientApiUrl: string;
  ServerApiUrl: string;
  UcarecdnUrl: string;
  TokenRefreshWindowMinutes: number;
};

const DEFAULT_TOKEN_REFRESH_WINDOW_MINUTES = 0;

export const apiConfig: ApiConfig = {
  ClientApiUrl: import.meta.env.VITE_CLIENT_API_ENDPOINT,
  ServerApiUrl: import.meta.env.VITE_SERVER_API_ENDPOINT,
  UcarecdnUrl: import.meta.env.VITE_UCARECDN_URL,
  TokenRefreshWindowMinutes: import.meta.env.VITE_TOKEN_REFRESH_WINDOW_MINUTES
    ? +import.meta.env.VITE_TOKEN_REFRESH_WINDOW_MINUTES
    : DEFAULT_TOKEN_REFRESH_WINDOW_MINUTES,
};
